import { FC } from 'react';

import { PlansCardSkeleton, PlansListSkeletonGrid } from './PlansListSkeleton.styles';

export const PlansListSkeleton: FC = () => {
    return (
        <PlansListSkeletonGrid>
            <PlansCardSkeleton />
            <PlansCardSkeleton />
            <PlansCardSkeleton />
        </PlansListSkeletonGrid>
    );
};
